export default "__VITE_ASSET__538aa4d7__"